// Ukrainian
export const uk = {
    weeklyRewards: 'Тижневі нагороди через',
    days: 'днів',
    hours: 'год',
    minutes: 'хв',
    seconds: 'сек',
    authenticating: 'Автентифікація',
    verifyWallet: 'Будь ласка, зачекайте, поки ми перевіряємо ваш гаманець',
    authRequired: 'Потрібна автентифікація',
    authFailed: 'Помилка автентифікації. Будь ласка, спробуйте ще раз.',
    points: 'Бали',
    rank: 'Ранг',
    of: 'з',
    players: 'гравців',
    weeklyTopPlayers: 'Кращі гравці тижня',
    thisWeekLeaderboard: 'Рейтинг цього тижня',
    rankingsReset: 'Рейтинг скидається щонеділі опівночі UTC',
    yourPoints: 'Ваші бали',
    dailyRewardAvailable: 'Доступна щоденна нагорода!',
    nextClaimAvailable: 'Наступне отримання доступне через:',
    claimDailyReward: 'Отримати щоденну нагороду',
    claiming: 'Отримання...',
    multiplier: 'Множник',
    bonusPointsMultiplier: 'Множник бонусних балів',
    outOf: 'з',
    loading: 'Завантаження...',
    errorLoading: 'Помилка завантаження',
    noEntries: 'Поки що немає записів',
    leaderboard: 'Рейтинг',
    tasks: 'Завдання',
    rules: 'Правила',
    profile: 'Профіль',
    comingSoon: 'Скоро...',
    completedTasks: 'Виконані завдання',
    dailyRewardsClaimed: 'Отримано щоденних нагород',
    times: 'разів',
    recentActivity: 'Остання активність',
    noRewardsClaimed: 'Ще не отримано нагород',
    dailyReward: 'Щоденна нагорода',
    howItWorks: 'Як це працює',
    welcomeMessage:
        'Ласкаво просимо до Coinomi Rewards! Заробляйте бали, виконуючи різні завдання та підіймайтесь у рейтингу.',
    dailyRewardsTitle: 'Щоденні нагороди',
    dailyRewardsRules: [
        'Отримуйте щоденну нагороду кожні 24 години',
        'Кожне отримання дає вам 100 балів',
        'Бали множаться на ваш множник',
    ],
    multiplierBonusesTitle: 'Бонуси множника',
    multiplierBonusesRules: [
        'Почніть з множника 1x',
        'Підключіть Telegram для бонусу +10%',
        'Підтвердіть email для бонусу +10%',
        'Бонуси складаються для максимальної винагороди',
    ],
    leaderboardTitle: 'Рейтинг',
    leaderboardRules: [
        'Змагайтеся з іншими гравцями',
        'Рейтинг оновлюється в реальному часі',
        'Кращі гравці отримують спеціальні нагороди',
    ],
    boostEarningsTitle: 'Збільште свій заробіток',
    boostEarningsRules: [
        'Виконуйте завдання для отримання бонусів',
        'Приєднуйтесь до нашої спільноти в Telegram',
        'Залишайтеся активними для максимальних нагород',
    ],
    challenges: 'Завдання',
    telegramChallenge: 'Завдання Telegram',
    emailChallenge: 'Завдання Email',
    connectTelegram: "Зв'язати з Telegram",
    shareEmail: 'Поділитися Email',
    telegramSuccess: '🎉 Вітаємо! Тепер ви отримуєте постійний бонус 10% на всі нагороди!',
    telegramPrompt:
        "Зв'яжіть свій акаунт Telegram для отримання постійного бонусу 10% на всі нагороди!",
    emailSuccess: '🎉 Вітаємо! Тепер ви отримуєте постійний бонус 10% на всі нагороди!',
    emailPrompt: 'Поділіться своїм email для отримання постійного бонусу 10% на всі нагороди!',
    connectEmail: "Зв'язати Email",
    cancel: 'Скасувати',
    emailPrivacy:
        'Ми використовуємо ваш email лише для важливих оновлень та сповіщень про нагороди.',
    connectYourEmail: "Зв'яжіть свій Email",
    emailBonus: '🎉 Отримайте постійний бонус 10% на всі нагороди, підключивши свій email!',
    enterValidEmail: 'Будь ласка, введіть дійсну email адресу',
    emailAddress: 'Email адреса',
    errorSavingEmail: 'Помилка збереження email. Будь ласка, спробуйте ще раз.',
    claimButton: 'Отримати',
    earnedReward: 'Зароблена нагорода',
    rewardValue: '{{amount}} Балів',
    claimingReward: 'Отримання...',
    claimSuccess: 'Успішно отримано {{amount}} балів!',
    claimError: 'Не вдалося отримати нагороду. Будь ласка, спробуйте ще раз.',
    privacyDisclaimer:
        "Coinomi не збирає особисті дані; стороння система безпечно керує балами та соціальними зв'язками.",
    streakBonus: 'Бонус за серію',
    streakDays: '{{days}}/5 Днів',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Додатково',
    streakDescription: 'Отримуйте нагороду 5 днів поспіль для максимального бонусу',
    streakToday: 'Сьогодні',
    streakMissed: 'Пропущено',
    streakComplete: 'Завершено',
    streakActive: 'Активна серія',
    streakLost: 'Серію втрачено',
    streakNext: 'Наступний',
    home: 'Головна',
    currentStreak: 'Поточна серія',
    totalClaims: 'Всього отримано',
    userStats: 'Ваша статистика',
    referrals: 'Реферали',
    referralProgram: 'Реферальна програма',
    howReferralWorks: 'Як працюють реферали:',
    referralSteps: [
        'Поділіться своїм реферальним посиланням з друзями',
        'Коли вони приєднуються за вашим посиланням, вони стають вашими рефералами',
        'Заробляйте бонусні бали за кожного активного реферала',
        'Відстежуйте своїх рефералів та заробіток тут',
    ],
    referralRewards: 'Нараховуються реферальні бали:',
    referralBonuses: ['100 балів за кожного реферала', '10% від усіх балів, які заробляє реферал'],
    yourReferralLink: 'Ваше реферальне посилання',
    copyToClipboard: 'Копіювати в буфер обміну',
    linkCopied: 'Посилання скопійовано в буфер обміну!',
    totalReferrals: 'Всього рефералів',
    yourReferralCode: 'Ваш реферальний код',
    referralCodeCopied: 'Реферальний код скопійовано!',
    editReferralCode: 'Редагувати реферальний код',
    editReferralCodeInstructions:
        'Виберіть новий реферальний код. Він повинен містити щонайменше 5 символів і може включати літери та цифри.',
    newReferralCode: 'Новий реферальний код',
    referralCodeRequirements: 'Мінімум 5 символів, тільки літери та цифри',
    updating: 'Оновлення...',
    update: 'Оновити',
    referralCodeTaken: 'Цей реферальний код вже зайнятий',
    haveReferralCode: 'Маєте реферальний код?',
    enterReferralCodePrompt:
        "Якщо хтось запросив вас, введіть їхній код тут, щоб зв'язати акаунти.",
    enterReferralCode: 'Введіть реферальний код',
    enterReferralCodeInstructions: 'Введіть реферальний код, яким з вами поділилися.',
    referralCode: 'Реферальний код',
    referralCodeFormat: 'Тільки літери та цифри',
    submitting: 'Відправка...',
    submit: 'Відправити',
    enterCode: 'Введіть код',
    pleaseAddtoken: 'Будь ласка, додайте параметр token до URL',
    authenticationError: 'Сталася помилка під час автентифікації',
    noUserFound: 'Користувача не знайдено',
    userNotFoundMessage: 'Не вдалося знайти дані користувача',
    backToHome: 'Повернутися на головну',
    retry: 'Спробувати ще раз',
    baseMultiplier: 'Базовий множник',
    telegramBonus: 'Бонус Telegram',
    referralChallenge: 'Реферальне завдання',
    referralChallengePrompt:
        'Запросіть друзів та заробляйте бонусні бали! Отримайте 100 балів за кожного реферала плюс 10% від їхнього заробітку.',
    startReferring: 'Почати запрошувати',
    referralSuccess: '🎉 Вітаємо! Ви успішно запросили користувачів і заробляєте бонусні бали!',
    unranked: 'Без рангу',
    noPlayersYet: 'Станьте першим, хто приєднається!',
    shareVia: 'Поділитися через',
    shareOn: 'Поділитися в {{network}}',
    shareInviteText:
        '🚀 Я заробляю безкоштовну криптовалюту з @CoinomiWallet!\n\nЗавантажте Coinomi з coinomi.com/downloads і введіть мій реферальний код {{referralCode}}, щоб отримати бонус при приєднанні до #Coinomi Rewards у додатку.',
    // Twitter Challenge
    twitterChallenge: 'Twitter Виклик',
    connectTwitter: 'Підключити Twitter',
    twitterSuccess: '🎉 Вітаємо! Тепер ви отримуєте постійний 10% бонус на всі винагороди!',
    twitterPrompt:
        'Підключіть свій обліковий запис Twitter, щоб отримати постійний 10% бонус на всі винагороди!',
    pleaseAddUserId: 'Будь ласка, додайте параметр userId до URL',
    emailChallengePrompt:
        'Поділіться своїм email для отримання постійного бонусу 10% на всі нагороди!',
    emailChallengeSuccess: '🎉 Підключено! Тепер ви отримуєте постійний бонус 10% на всі нагороди!',
    followKoalaWalletChallenge: 'Підпишіться на @coinomiWallet у Twitter, щоб підтримати нас!',
    twitterAuthSuccessTitle: 'Twitter успішно підключено!',
    twitterAuthSuccessMessage:
        'Обліковий запис Twitter успішно підключено. Тепер ви можете продовжити користуватися додатком.',
    continueToApp: 'Продовжити до додатку',
    twitter_like: 'Вподобали твіт',
    twitter_retweet: 'Ретвітнули твіт',
    disconnect: 'Відключити',
    followCoinomiWallet: 'Слідкуйте за @coinomiWallet у Twitter, щоб підтримати нас!',
    connectedBonus: '🎉 Підключено! Тепер ви отримуєте постійний 10% бонус на всі винагороди!',
};
